import React from "react";

const SearchField = ({ value = "", onChange, className = "" }) => {
  return (
    <div
      className={`flex w-full max-w-[285px] items-center rounded-full bg-blue-100 px-6 py-2 ${className}`}
    >
      <input
        type="text"
        placeholder="Search"
        className="w-full flex-1 bg-blue-100 text-lg text-blue-900 placeholder-blue-900 outline-none"
        value={value}
        onChange={onChange}
      />

      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19"
        viewBox="0 0 23 19"
        fill="none"
        className="w-5 basis-5"
      >
        <path
          d="M13.3559 13.1453C11.6025 14.659 9.59688 15.3129 7.29609 15.1971C3.68306 15.0141 0.455615 12.0021 0.0509942 8.54799C-0.379015 4.88201 1.96144 1.63522 5.14922 0.478265C9.69367 -1.16952 14.8522 1.61083 15.7011 6.20664C16.0042 7.84376 15.7979 9.40466 15.0442 10.8939C14.8934 11.1927 14.9537 11.336 15.2171 11.528C17.5544 13.2261 19.8838 14.9364 22.2068 16.6513C22.4511 16.8311 22.7018 17.043 22.8526 17.293C23.1398 17.7686 22.989 18.3585 22.559 18.7106C22.1179 19.0719 21.507 19.1054 21.0167 18.7518C19.8489 17.9119 18.6953 17.0567 17.5354 16.2077C16.1502 15.1925 14.7649 14.1758 13.3575 13.1453H13.3559ZM7.91651 1.38676C4.29713 1.40048 1.41718 4.16863 1.43147 7.61968C1.44575 11.0738 4.37489 13.8785 7.93872 13.8496C11.5375 13.8206 14.4206 11.0235 14.4063 7.57853C14.392 4.14729 11.4835 1.37304 7.91651 1.38676Z"
          fill="#012D61"
        />
      </svg>
    </div>
  );
};

export default SearchField;
